module.exports = __webpack_public_path__ + "static/img/img_charge_pricing.127ce809.png";